import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../store/reducers';
import { setAvatarLocally } from '../../store/reducers/App/appSlice';
import AdditionalSelectInput from '../../views/AdditionalSelectInput/AdditiondalSelectInput';
import Button from '../Button/Button';
import Paragraph from '../Typography/Paragraph/Paragraph';
import styles from './PhotoSelect.module.scss';
export const pickUserAvatar = (collection, filename) => {
    const asset = collection.find((el) => el.value === filename);
    return asset ? asset.asset : collection[0].asset;
};
const PhotoSelect = ({ isOpen, title, collections, type, backHandler, showSaveButton = true, saveHandler, forwardRef }) => {
    const [contents, setContents] = useState(collections[0].contents || []);
    const dispatch = useAppDispatch();
    const [active, setActive] = useState(0);
    const userInfo = useSelector((state) => state.app.userInfo);
    const collectionHandler = useCallback((e) => {
        var _a;
        const { value } = e;
        const collection = collections.find((el) => el.value === value);
        setContents((_a = collection === null || collection === void 0 ? void 0 : collection.contents) !== null && _a !== void 0 ? _a : []);
    }, [collections]);
    useEffect(() => {
        var _a;
        const asset = (_a = collections[0].contents) === null || _a === void 0 ? void 0 : _a.find((el) => el.value === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.photo));
        setActive(asset ? asset.id : 0);
    }, [collections, userInfo === null || userInfo === void 0 ? void 0 : userInfo.photo]);
    const handleSave = () => {
        const selected = contents.find((el) => el.id === active);
        if (selected)
            saveHandler(selected.value);
    };
    const handleClick = (id) => {
        var _a;
        //Prevent unnecessary store update
        if (id !== active) {
            //@To-do for Musa Musazada -- For now we only do this for profile
            if (type === 'profile') {
                const asset = (_a = collections[0].contents) === null || _a === void 0 ? void 0 : _a.find((el) => el.id === id);
                if (asset) {
                    dispatch(setAvatarLocally(asset.value));
                }
            }
            setActive(id);
        }
    };
    return (_jsxs("div", Object.assign({ className: cn(styles.wrapper, isOpen && styles.animate) }, { children: [_jsxs("div", Object.assign({ className: cn(styles.header) }, { children: [_jsx(Paragraph, { className: cn(styles.title), title: title }), _jsx(AdditionalSelectInput, { onChange: collectionHandler, options: collections, selectedOption: collections[0].label })] })), _jsx("div", Object.assign({ className: cn(styles.content) }, { children: contents.map((el) => (_jsx("div", Object.assign({ className: cn(styles.photo, active === el.id && styles.active) }, { children: _jsx("div", Object.assign({ className: cn(styles.pictureWrapper, 'd-flex justify-content-center align-items-center h-100'), onClick: () => handleClick(el.id) }, { children: el.value !== 'logo' ? (_jsx("img", { src: el.asset, alt: 'Avatar' })) : (_jsx(el.asset, {})) })) }), el.id))) })), _jsxs("div", Object.assign({ className: cn(styles.footer, !showSaveButton && 'justify-content-start') }, { children: [_jsx(Button, { onClick: backHandler, size: "md", color: 2, text: "Back" }), showSaveButton && (_jsx(Button, { onClick: handleSave, size: "md", color: 1, text: "Save Changes" }))] }))] })));
};
export default PhotoSelect;
